// Calendar-accurate length of service (years / months / days) from the join date.
// `endDate` defaults to today; pass the last working day for leavers.
export function lengthOfService(joinDate, endDate) {
  if (!joinDate) return null;
  const start = new Date(String(joinDate).slice(0, 10) + 'T00:00:00');
  if (Number.isNaN(start.getTime())) return null;
  const end = endDate ? new Date(String(endDate).slice(0, 10) + 'T00:00:00') : new Date();
  end.setHours(0, 0, 0, 0);
  if (end < start) return { years: 0, months: 0, days: 0, totalDays: 0, label: 'Not started', short: '—', future: true };

  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();
  let days = end.getDate() - start.getDate();
  if (days < 0) {
    months -= 1;
    // Count days from the join-day anniversary in the previous month (clamped to that month's length).
    const prevMonthLen = new Date(end.getFullYear(), end.getMonth(), 0).getDate();
    const anchor = new Date(end.getFullYear(), end.getMonth() - 1, Math.min(start.getDate(), prevMonthLen));
    days = Math.round((end - anchor) / 86400000);
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  const totalDays = Math.round((end - start) / 86400000);
  const parts = [];
  if (years) parts.push(`${years} year${years === 1 ? '' : 's'}`);
  if (months) parts.push(`${months} month${months === 1 ? '' : 's'}`);
  if (days || parts.length === 0) parts.push(`${days} day${days === 1 ? '' : 's'}`);
  const short = [years && `${years}y`, months && `${months}m`, `${days}d`].filter(Boolean).join(' ');
  return { years, months, days, totalDays, label: parts.join(', '), short, future: false };
}
